import { ElementDetails } from "@/lib/types";
import { RowColumnPropsFields } from "./utils";

export const details = {
  name: "Row",
  description: "A container for other elements",
  category: "Container",
  grid: {},
  ...RowColumnPropsFields("Row"),
} as ElementDetails;
